
import * as types from '../actions/actionsTypes';
import { setup, setupStepEnrollMobile } from './initialState';

// TODO à passer en TS
export default function languageReducer(state = setup, action) {
  switch (action.type) {
    
    case types.SET_LANGUAGE:
      return {
        ...state,
        language: action.payload.language.language
      };
      default:
        return {
          ...state
        };
    }
  }